import { Dispatch, useEffect, useState } from 'react';
// import { getServiceList } from '../../../api/services';
import warnImage from '../../../assets/images/warn-yellow.png';
import { ModalWrap } from '../../component/modal-wrap';
import { CreateEnvModal } from '../game-info/components/create-env-modal';
// import { IServiceData } from '../../../model';
import { fetchEnvList } from '../../../api/game/env';
import {
  GamesAction,
  ReduxGamesActionType,
} from '../../../store/modules/games';
import { useDispatch } from 'react-redux';
import {
  formatGameParamsByLocationPathname,
  getPathnameBySwitchGameEnv,
} from '../lib';
import { useHistory } from 'react-router-dom';
import { IGameEnvModel } from '../../../model/api-modules/env';
import { IAPIGameItem } from '../../../model/api-modules';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly selectedGame: IAPIGameItem;
  readonly onClose: () => void;
  readonly showCheckModal: boolean;
  readonly onCloseCheckModal: () => void;
}

export const HelpCreateEnvModal = (props: IProps) => {
  const history = useHistory();
  const [showCreateDrawer, setShowCreateDrawer] = useState<boolean>(false);
  // const [tipsModal, setTipsModal] = useState<boolean>(true);
  // const [serviceData, setServiceData] = useState<ReadonlyArray<IServiceData>>(
  //   []
  // );
  const gamesDispatch = useDispatch<Dispatch<GamesAction>>();
  const [createSuccess, setCreateSuccess] = useState<boolean>(false);
  const [envList, setEnvList] = useState<IGameEnvModel[]>([]);

  // // 获取服务开通结构数据
  // const getServicesData = async () => {
  //   const res = await getServiceList();
  //   const data: IServiceData[] = [];
  //   res?.forEach((item) => {
  //     const parentItem = data.find(
  //       (dataItem) => dataItem.id === item.ParentName
  //     );
  //     if (parentItem) {
  //       Object.assign(parentItem, {
  //         children: [...parentItem.children, { id: item.id, name: item.Name }],
  //       });
  //     } else {
  //       data.push({
  //         id: item.ParentName,
  //         children: [{ id: item.id, name: item.Name }],
  //       });
  //     }
  //   });
  //   setServiceData(data);
  // };

  const handleOk = async () => {
    await getEnvList();
    setShowCreateDrawer(true);
    // setTipsModal(false);
    props.onCloseCheckModal();
    return true;
  };

  const getEnvList = async () => {
    if (props.selectedGame.gameID) {
      const res = await fetchEnvList(props.selectedGame.gameID);
      if (res) {
        setEnvList(res);
        gamesDispatch({
          type: ReduxGamesActionType.SET_ALL_ENVS,
          result: res,
        });
      }
    }
  };

  const onCreateSuccess = async () => {
    setCreateSuccess(true);
  };

  useEffect(() => {
    if (createSuccess) {
      getEnvList();
    }
  }, [createSuccess]);

  useEffect(() => {
    const { envId } = formatGameParamsByLocationPathname(location.pathname);
    // 无环境情况下如果添加环境成功，替换选中该环境
    if (createSuccess) {
      history.replace(getPathnameBySwitchGameEnv(Number(envId)));
    }
  }, [envList]);

  return (
    <>
      {props.showCheckModal ? (
        <ModalWrap
          width="450px"
          onOk={handleOk}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('go_to_add')}
          onClose={props.onClose}
          title={
            <p className="fail-title">
              <img
                src={warnImage}
                alt="Warning"
                style={{ marginRight: '10px', marginTop: '-2px' }}
              />
              <span>{getFormatMessage('tips')}</span>
            </p>
          }
          className="edit-modal"
        >
          <div style={{ lineHeight: '22px', marginBottom: '66px' }}>
            {getFormatMessage('title_no_env_desc')}
          </div>
        </ModalWrap>
      ) : null}
      {/* {showCreateDrawer ? ( */}
      <CreateEnvModal
        // serviceData={serviceData}
        onClose={() => setShowCreateDrawer(false)}
        refresh={onCreateSuccess}
        selectedGame={props.selectedGame}
        isShow={showCreateDrawer}
      />
      {/* ) : null} */}
    </>
  );
};
